import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { createLeadPipelineStage } from '../api/leadPipelineStages';
import type { LeadPipelineStageFormValues } from '../types';

export function useCreateLeadPipelineStage(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: LeadPipelineStageFormValues) => createLeadPipelineStage(data),
    onSuccess: () => {
      notification.success({ message: 'Pipeline stage created successfully' });
      void queryClient.invalidateQueries({ queryKey: ['settings-lead-pipeline-stages'] });
      void queryClient.invalidateQueries({ queryKey: ['lead-pipeline'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to create pipeline stage' });
    },
  });
}
